// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"beq_a bii_b bii_va bii_rv bii_rw bii_vu","PanelFooter--link":"beq_b"};